import webActivityController from '../webActivity';
import apiClient from '../apiClient';
import { setCampaignRenderState } from '../store/dispatcher';
import CampaignApiClient from './campaignApiClient';
import CampaignController from './campaignController';

/**
 * IMBEE-8954 — the wired singleton, mirroring `apiClient/index.ts`'s own module-level singleton
 * convention (both `App.tsx` and `Widget/index.tsx` already import/use `apiClient` this way).
 *
 * The identity getters read `apiClient`'s live fields rather than snapshotting them once — the
 * visitor token and widget token can both change after this module is first imported (session
 * creation, token refresh), and every campaign call must carry the CURRENT value, not the value at
 * import time.
 *
 * This module is also the only seam between the framework-free controller and redux: the
 * controller emits a render state, this dispatches it.
 */
const campaignApiClient = new CampaignApiClient({
  getVisitorToken: () => apiClient.visitorToken,
  getWidgetToken: () => apiClient.widgetToken,
});

const campaignController = new CampaignController(campaignApiClient, setCampaignRenderState, () =>
  webActivityController.whenFirstBeaconSettled(),
);

export default campaignController;
